"use client";

import { useState, useEffect } from "react";
import { SpotlightItem } from "@/data/spotlight";

// Client-side hydration wrapper for adding interactivity to server-rendered content
interface SpotlightHydrationProps {
  children: React.ReactNode;
  spotlight?: SpotlightItem[];
}

export default function SpotlightHydration({ children }: SpotlightHydrationProps) {
  const [isHydrated, setIsHydrated] = useState(false);
  
  // Mark as hydrated once client-side code has executed
  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // Add client-side event handlers and animations here if needed

  return (
    <div className={`spotlight-wrapper ${isHydrated ? 'hydrated' : ''}`}>
      {children}
    </div>
  );
}